import SellersCounterContext from './index.ts';
import { getSellers, Seller } from '@api/apiClient/sellers';
import { ReactNode, useEffect, useState } from 'react';
import { useAuth } from '../AuthenticationContext';
import { useQuery } from 'react-query';

interface ISellersCounterProviderProps {
  children: ReactNode;
}

const SellersCounterProvider = (props: ISellersCounterProviderProps) => {
  const [sellersList, setSellersList] = useState<Seller[]>([]);
  const [sellersNotFound, setSellersNotFound] = useState<boolean>(true);
  const [value, setValue] = useState<number>(0);

  const auth = useAuth();

  const query = useQuery({
    queryKey: ['sellers'],
    queryFn: () => getSellers(),
    retry: 1,
    enabled: auth.isAuthenticated
  });

  useEffect(() => {
    if (query.data) {
      const length: number = query.data.items.length ?? 0;
      setSellersList(query.data.items);
      setSellersNotFound(!length);
      setValue(length);
    }
  }, [query.data?.items]);

  const update = () => {
    query.refetch();
  };

  return (
      <SellersCounterContext.Provider
          value={{
            isFetching: query.isFetching,
            sellersList,
            sellersNotFound,
            update,
            value
          }}
      >
        <>{props.children}</>
      </SellersCounterContext.Provider>
  );
};

export default SellersCounterProvider;
